import styled from 'styled-components'

import { CurrencyIcon } from '../currency-icon'

import type { CurrencyModel } from '@root/entities/currency/model'

type CurrencyPairIconsProps = {
  base: CurrencyModel
  quote: CurrencyModel
  size?: number
}

export const CurrencyPairIcons: React.FC<CurrencyPairIconsProps> = ({
  base,
  quote,
  size = 32,
}) => {
  return (
    <Icons $size={size}>
      <QuoteCurrencyIcon size={size} currency={quote} />
      <BaseCurrencyIcon size={size} currency={base} />
    </Icons>
  )
}

const Icons = styled.div<{ $size: number }>`
  position: relative;
  display: inline-block;
  width: ${({ $size }) => $size * 2 - $size / 4}px;
  height: ${({ $size }) => $size}px;
`

const BaseCurrencyIcon = styled(CurrencyIcon)`
  position: absolute;
  left: 0;
`

const QuoteCurrencyIcon = styled(CurrencyIcon)`
  position: absolute;
  right: 0;
`
